import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";

import {navigateToRouteAndHash} from "../../hooks/navigationHooks";
import {ALL_SOURCES_TO_ROUTE} from "../../redux/objectParametersSlice";
import {clearedComments, updateMultipleParamsAndValidateAndSubmitFormThunk} from "../../redux/objectParametersThunk";
import {leaseholdParams} from "../../redux/sectionIIThunk";
import ParameterInputCheckbox from "./ParameterInputCheckbox";

//#18222 Erbbaurecht in Überblick nicht editierbar, setzt auch zugehörige Parameter
export default function ParameterInputCheckboxLeasehold(props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const onForward =
        props.parameterType === "REGISTER"
            ? null
            : () => navigateToRouteAndHash(navigate, ALL_SOURCES_TO_ROUTE["register"], "register_leasehold_input");

    return (
        <ParameterInputCheckbox
            {...props}
            doForward={onForward}
            setNullOrEmpty={(value) => setLeaseholdParams(dispatch, value)}
        />
    );
}

export function setLeaseholdParams(dispatch, value) {
    // Ein Sammel-Update statt sieben Einzel-Updates: die liefen nebenläufig, ihre Antworten konnten
    // sich überholen, und validiert wurde jeweils ein Zwischenstand (Detailfelder schon leer,
    // prop_leasehold noch gesetzt). Jetzt wird einmal der fertige Stand geprüft und geschickt.
    const params = leaseholdParams(value);
    dispatch(updateMultipleParamsAndValidateAndSubmitFormThunk("REGISTER", params, clearedComments(params)));
}
